import { useContext } from 'react'
import { ErrorIndicatorsContext } from '~/components/DrawingCanvas/Products/contexts/ErrorIndicatorsContext'

export const useErrorIndicatorsContext = () => {
  const value = useContext(ErrorIndicatorsContext)
  if (!value) throw new Error('Must use within ErrorIndicatorsProvider')
  return value
}
